export const SET_LISTEN_RECORD_MODAL_VISIBLE =
  'SET_LISTEN_RECORD_MODAL_VISIBLE';
export const SET_CURRENT_RECORD_URL = 'SET_CURRENT_RECORD_BUFFER';
export const CLEAR_CURRENT_RECORD_URL = 'CLEAR_CURRENT_RECORD_BUFFER';
export const SET_CURRENT_CALL_INFO = 'SET_CURRENT_CALL_INFO';
export const CLEAR_CURRENT_CALL_INFO = 'CLEAR_CURRENT_CALL_INFO';
